"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const amountUtils_1 = require("../../../util/amountUtils");
const KPIContainer = styled_components_1.default.div `
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: ${theme_1.theme.spacing(1)} ${theme_1.theme.spacing(2)};
  width: 100%;
  padding: ${theme_1.theme.spacing(1)} 0;
`;
const NumberUnit = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
`;
const Number = styled_components_1.default.span `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(3)};
  line-height: 1.2;
  white-space: nowrap;
  text-align: right;
`;
const Unit = styled_components_1.default.span `
  ${theme_1.theme.fontSize(-1)};
  white-space: nowrap;
  align-self: flex-end;
  padding-left: ${theme_1.theme.spacing(0.5)};
`;
const TitleBlock = styled_components_1.default.span `
  display: flex;
  flex-direction: column;
  line-height: 1.3;
`;
const Title = styled_components_1.default.span `
  ${theme_1.theme.fontBold};
  ${theme_1.theme.fontSize(-1)};
`;
const Subtitle = styled_components_1.default.span `
  ${theme_1.theme.fontSize(-1)};
  color: ${theme_1.theme.colors.grey(2)};
`;
const formatValue = (item) => {
    if (item.value === undefined)
        return "N/A";
    const formatted = (0, amountUtils_1.formatNumber)(item.value, item.digits) ?? "N/A";
    if (item.showPositiveSign && item.value > 0) {
        return `+${formatted}`;
    }
    return formatted;
};
exports.default = ({ items }) => {
    return ((0, jsx_runtime_1.jsx)(KPIContainer, { children: items.map((item, index) => ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)(NumberUnit, { children: [(0, jsx_runtime_1.jsx)(Number, { style: { color: item.color }, children: formatValue(item) }), (0, jsx_runtime_1.jsx)(Unit, { children: item.unit ?? "" })] }), (0, jsx_runtime_1.jsxs)(TitleBlock, { children: [(0, jsx_runtime_1.jsx)(Title, { children: item.title }), item.subtitle && (0, jsx_runtime_1.jsx)(Subtitle, { children: item.subtitle })] })] }, index))) }));
};
